import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import toolbar from "./components/elements/Toolbar";
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueGAPI from "vue-gapi";

// create the 'options' object
const apiConfig = {
  /*apiKey: "<YOUR_API_KEY>",*/
  clientId: "849822970072-k1a0mp2v7i64r9bgg8ml6bvlfdn72b1g.apps.googleusercontent.com",
  //discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
  scope: "profile email",
    //cookiepolicy: 'single_host_origin',
	// see all available scopes here: https://developers.google.com/identity/protocols/googlescopes'
};

// Use the plugin and pass along the configuration
Vue.use(VueGAPI, apiConfig);

// Global Default Settings für Axios
axios.defaults.timeout = 5000;

Vue.use(VueAxios, axios);

//Vue.prototype.$deferredPrompt = null;
Vue.prototype.$EventBus = new Vue();

Vue.component('toolbar', toolbar);

Vue.config.productionTip = false
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
